import axios from '@/utils/http';

export default (assetId, legalCurrencyId) => {
  return axios
    .get(`/curr_price/${assetId}/${legalCurrencyId}`)
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};
